import React from "react";
import styles from "./process-line.module.scss";

type Props = {};

const ProcessLine = (props: Props) => {
  const width = 380;

  return (
    <div className={styles.processLine}>
      <span className={styles.from}>FROM</span>
      <span className={styles.to}>TO</span>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={40} fill="none" className={styles.animated}>
        <path
          id="myPath"
          stroke="#ADF82A"
          strokeDasharray="6 5"
          strokeWidth={2}
          d={`M1.357 ${46}v-27.58c0-5.522 4.478-10 10-10H${width - 11}c5.523 0 10 4.478 10 10v27.58`}
        />
      </svg>
    </div>
  );
};

export default ProcessLine;
